import React, { PropsWithChildren } from 'react';

import { useAccessFilterCheck } from '../hooks';
import { AccessLimitFilter } from '../types';

interface ContentGuardProps extends AccessLimitFilter {
    fallbackContent?: React.ReactNode;
}

export default function ContentGuard({ children, fallbackContent, ...filter }: PropsWithChildren<ContentGuardProps>) {
    const passesFilter = useAccessFilterCheck(filter);

    if (passesFilter) {
        return <>{ children }</>;
    }

    if (fallbackContent) {
        return <>{ fallbackContent }</>;
    }

    return null;
}
